<template>
    <el-dialog
        title="订单详情"
        :visible.sync="visible"
        width="616px"
        custom-class="pay-order-dialog"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :before-close="close"
        :show-close="true"
    >
        <div class="detail-info">
            <div class="group">
                <div class="title-area">
                    <div class="text-area">
                        <div class="index">1</div>
                        <div class="index-title">
                            购买产品
                        </div>
                    </div>
                </div>
                <div class="product-detail">
                    <div class="left-info">
                        <div class="detail-list">
                            <div class="item">
                                <div class="t pro-title">{{ productDetail.auth_type }}</div>
                            </div>
                            <div class="item">
                                <div class="t">购买时长</div>
                                <div class="v">{{ productDetail.year }}</div>
                            </div>
                            <div v-show="productDetail._auth_type===3" class="item">
                                <div class="t">用户数</div>
                                <div class="v">{{ productDetail.net_sum }}人</div>
                            </div>
                        </div>
                    </div>
                    <div class="price-num">
                        <span class="price">
                        {{ productDetail.pay_price }}
                        </span>
                    </div>
                </div>
            </div>
            <div class="group invoice">
                <div class="title-area">
                    <div class="text-area">
                        <div class="index">2</div>
                        <div class="index-title">
                            开票信息
                        </div>
                    </div>
                </div>
                <div class="list">
                    <div class="item" v-for="item in invoiceFields" :key="item.name">
                        <div class="t">{{ item.title }}</div>
                        <div class="v">{{ invoiceDetail[item.name] }}</div>
                    </div>
                </div>
                <!--                <div class="edit-span" @click="showInvoice">-->
                <!--                    编 辑-->
                <!--                </div>-->
            </div>
            <div class="group account">
                <div class="title-area">
                    <div class="text-area">
                        <div class="index">
                            3
                        </div>
                        <div class="index-title">收款账户</div>
                    </div>
                </div>
                <div class="list">
                    <div v-for="item in transferFields" :key="item.name" class="item">
                        <div class="t">{{ item.title }}</div>
                        <div class="v">{{ transferData[item.name] }}</div>
                    </div>
                </div>
                <div class="copy" @click="copy">
                    复 制
                </div>
            </div>
            <div class="else-data">
                <div class="title">
                    资料下载
                </div>
                <div class="data-list">
                    <div>
                        <a target="_blank" :href="link.price"><i class="el-icon-document"></i>报价单</a>
                    </div>
                    <div>
                        <a target="_blank" :href="link.request"> <i class="el-icon-wallet"></i>请款单</a>
                    </div>
                    <div>
                        <a target="_blank" :href="link.deal"><i class="el-icon-paperclip"></i>购买合同</a>
                    </div>
                </div>
            </div>
            <div class="qr-area" v-show="pay.show">
                <div class="el-pay-type">
                    <el-radio-group v-model="pay.type">
                        <el-radio label="wx">微信</el-radio>
                        <el-radio label="ali">支付宝</el-radio>
                    </el-radio-group>
                </div>
                <div class="qr-img">

                </div>
            </div>
        </div>
        <div slot="footer" class="dialog-footer">
            <!--            <div class="cancel-btn">-->
            <!--                <div @click="close" class="title">取消订单</div>-->
            <!--            </div>-->
            <div class="save-btn">
                <div @click="createQrCode" class="title">
                    扫码付款
                </div>
            </div>
        </div>
    </el-dialog>
</template>
<script>

export default {
    props: ['show', 'invoice', 'product', 'transfer'],
    data() {
        return {
            pay: {
                type: 'wx',
                show: true,
            },
            visible: false,
            transferFields: [
                {title: '公司名称', name: 'title', value: ''},
                {title: '开户银行', name: 'bank', value: ''},
                {title: '对公号码', name: 'account', value: ''},
                // {title: '随机码',name:'mask',  value: ''},
                {title: '联系电话', name: 'invoice_tel', value: ''},
            ],
            productField: [
                {title: '产品类型', name: 'auth_type'},
                {title: '产品时间', name: 'year'},
                {title: '节点数', name: 'net_sum'},
                {title: '随机码', name: 'random_mask'},
            ],
            invoiceFields: [
                // {title: '种类', name: 'invoice_type'},
                {title: '开票抬头', name: 'header'},
                {title: '企业税号', name: 'no'},
                {title: '开户行', name: 'bank'},
                {title: '银行账号', name: 'account',},
                {title: '单位电话', name: 'tel',},
                {title: '地址', name: 'address',},
                // {title: '发送邮箱', name: 'mailbox'},
                // {title: '开票备注', name: 'tip'},
            ],
        }
    },
    mounted() {

    },
    computed: {
        link: function () {
            let base = 'https://pro.bigemap.com'
            let d = this.productDetail;
            let id = this.invoiceDetail;
            let pa = ['year=' + d._year, 'net_sum=' + d.net_sum, 'username=' + this.$store.state.userData.username, 'show_price=' + d.show_price, 'pay_price=' + d.pay_price,
                'auth_type=' + d._auth_type,
                'mask=' + d.random_mask,
                'header=' + decodeURIComponent(id.header),
                'address=' + decodeURIComponent(id.address || ''),
                'buy_type=' + d.buy_type,
                'invoice_type=' + id._invoice_type,
            ];
            pa = pa.join('&');
            return {
                price: base + '/wk/l/d?type=price&' + pa,
                request: base + '/wk/l/d?type=request&' + pa,
                deal: base + '/wk/l/d?type=deal&' + pa,
            };
        },
        transferData: function () {
            return this.transfer || {};
        },
        productDetail: function () {
            if (!this.product) {
                return {}
            }
            let detail = JSON.parse(JSON.stringify(this.product));
            detail._auth_type = detail.auth_type;
            if (detail.auth_type === 2) {
                detail.auth_type = 'Bigemap Pro 订阅版';
                detail.net_sum = 0;//清空节点数据
            } else {
                detail.auth_type = 'Bigemap Pro 企业版';
            }
            detail._year = detail.year;
            detail.year = detail.year + '年';
            return detail;
        },
        invoiceDetail: function () {
            if (!this.invoice) {
                return {}
            }
            let detail = JSON.parse(JSON.stringify(this.invoice));
            detail._invoice_type = detail.invoice_type;
            detail.invoice_type = detail.invoice_type === 'pu' ? "普票" : "专票";
            return detail;
        }
    },
    watch: {
        show: function (v) {
            this.visible = !!v;
        }
    },
    methods: {
        copy() {
            let text = [];
            this.transferFields.map(v => {
                text.push(v.title + ': ' + this.transferData[v.name] || '');
            });
            text = text.join("\r\n");
            if (navigator.clipboard) {
                this.$message.success('复制成功!');
                return navigator.clipboard.writeText(text)
            }
            const t = document.createElement('textarea')
            t.value = text
            document.body.appendChild(t)
            t.select();
            document.execCommand('copy')
            document.body.removeChild(t);
            this.$message.success('复制成功!');
        },
        close(type) {
            this.$emit('close', {type});
        },
        createQrCode() {

        },
    }
}
</script>
<style scoped lang="less">
.detail-info {
    position: relative;

    &::before {
        position: absolute;
        top: 10px;
        display: block;
        content: ' ';
        border-left: 2px dashed #b1dbfa;
        left: 43px;
        bottom: 40px;
    }

    .group {
        //padding: 15px 15px;
        //background: #fff;
        margin-bottom: 10px;
        display: flex;

        .text-area {
            display: flex;
            flex-direction: column;
            align-items: center;
            background: #f5f5f5;
            padding: 10px 0;
            justify-content: center;
        }

        .title-area {
            //background: transparent;
            width: 90px;
            position: relative;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;

            .index {
                font-size: 26px;
                color: #fff;
                width: 35px;
                text-align: center;
                display: flex;
                align-items: center;
                justify-content: center;
                height: 35px;
                border-radius: 50px;
                background: rgb(175, 217, 247);
            }

            .index-title {
                padding-top: 10px;
                font-weight: bold;
            }
        }

        .list {
            flex: 1;
            padding: 15px 0 15px 50px;
            background: url("~@/assets/images/shape.png") 0 repeat-y;
            //background-color: #fff;
            position: relative;

            &::before {
                position: absolute;
                top: 0;
                right: 0;
                display: block;
                content: ' ';
                left: 50px;
                background: #fff;
                bottom: 0;
            }

            &::after {
                position: absolute;
                top: 10px;
                display: block;
                content: ' ';
                border-left: 2px dashed #b1dbfa;
                left: 35px;
                bottom: 10px;
            }
        }

        .product-detail {
            padding: 20px 20px 20px 60px;
            flex: 1;
            position: relative;
            background: url("~@/assets/images/shape.png") 0 repeat-y;
            //background: #fff;
            &::before {
                position: absolute;
                top: 0;
                right: 0;
                display: block;
                content: ' ';
                left: 50px;
                background: #fff;
                bottom: 0;
            }

            &::after {
                position: absolute;
                top: 10px;
                display: block;
                content: ' ';
                border-left: 2px dashed #b1dbfa;
                left: 35px;
                bottom: 10px;
            }
        }
    }

    .product-detail {
        display: flex;

        .left-info {
            display: flex;
            flex: 1;

            .logo-img {
                padding: 0 10px 0 4px;
            }

            .detail-list {
                display: flex;
                flex-direction: column;
                justify-content: space-between;
                flex: 1;

                .item {
                    display: flex;
                    padding: 6px 0;
                    align-items: center;
                    flex: 1;
                    position: relative;
                    text-align: center;

                    .t {
                        color: #777;
                        width: 75px;
                        font-weight: 400;
                        text-align: justify;
                        text-align-last: justify;
                        flex-shrink: 0;
                        position: relative;

                        &:after {
                            display: block;
                            content: ':';
                            position: absolute;
                            right: -7px;
                            bottom: 2px;
                        }

                        &.pro-title {
                            &:after {
                                display: none;
                            }

                            width: unset;
                            color: #333;
                            font-size: 16px;
                            font-weight: 500;
                        }
                    }

                    .v {
                        padding-left: 20px;
                        color: #333333;
                        font-weight: bold;
                    }
                }
            }
        }

        .price-num {
            width: 100px;
            flex-shrink: 0;
            //padding-top: 26px;
            font-weight: bold;
            //display: flex;
            //padding-top: 43px;
            //align-items: end;
            font-size: 24px;
            color: #f6171b;
            position: relative;

            .price {
                position: absolute;
                right: 25px;
                bottom: 2px;

                &::after {
                    color: #f6171b;
                    display: block;
                    position: absolute;
                    content: '¥';
                    left: -13px;
                    bottom: 4px;
                    font-size: 14px;
                }
            }
        }
    }

    .account, .invoice {
        .list {
            .item {
                display: flex;
                padding: 6px 5px;
                position: relative;

                .tip {
                    font-weight: normal;
                    font-size: 13px;
                }

                .t {
                    width: 75px;
                    padding: 0 5px;
                    text-align: center;
                    text-align-last: justify;
                    flex-shrink: 0;
                    position: relative;

                    &:after {
                        display: block;
                        content: ':';
                        position: absolute;
                        right: -5px;
                        bottom: 0;
                    }
                }

                .v {
                    padding-left: 20px;
                    color: #333333;
                    font-weight: 500;
                }
            }
        }
    }

    .invoice {
        position: relative;

        .edit-span {
            position: absolute;
            right: 45px;
            bottom: 15px;
            //letter-spacing: 5px;
            cursor: pointer;
            padding: 5px 10px;
            font-size: 12px;
            color: #fff;
            background-color: #007ee2;
        }
    }

    .account {
        position: relative;

        .copy {
            position: absolute;
            right: 45px;
            bottom: 15px;
            //letter-spacing: 5px;
            cursor: pointer;
            padding: 5px 10px;
            font-size: 12px;
            color: #fff;
            background-color: #007ee2;
        }
    }

    .else-data {
        display: flex;
        margin-left: 90px;
        background-color: #fff;
        padding: 20px 10px;

        .title {
            width: 80px;
        }

        .data-list {
            flex: 1;

            display: flex;
            align-items: center;
            justify-content: space-around;

            > div {
                width: 25%;

                a {
                    color: #0085f3;
                    cursor: pointer;
                    font-weight: bold;

                    i {
                        padding-right: 5px;
                    }

                    text-decoration: underline;
                }
            }
        }
    }
}

.dialog-footer {
    display: flex;
    justify-content: space-around;

    .cancel-btn, .save-btn {
        width: 65%;
        text-align: center;
        padding: 10px;
        letter-spacing: 5px;
        cursor: pointer;
    }

    //.cancel-btn {
    //    color: #fff;
    //    background-color: rgba(180, 179, 179, 0.53);
    //}

    .save-btn {
        color: #fff;
        background-color: #007ee2;
    }
}

.qr-area {
    padding: 10px 0;
    background: #fff;
    border: 1px solid #eee;
    width: 260px;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 10px auto;

    .el-pay-type {
        display: flex;
        justify-content: center;
    }

    .qr-img {
        margin-top: 10px;
        width: 150px;
        height: 150px;
        border: 1px solid #e6be80;
        display: flex;
        text-align: center;
        align-items: center;
        justify-content: center;

        img {
            width: 130px;
            height: 130px;
        }
    }
}
</style>